var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get, post } from './api';
export const loadEvents = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/events/index' });
    // const response = mockEvents
    return response;
});
export const createTestEvent = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield post({ path: '/v1/events/create-test-event', data: {} });
    return response;
});
export const getPlayersWithUnknownSource = (eventId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get({ path: '/v1/events/get-players-with-unknown-source', params: { eventId } });
    return response;
});
